import { useEffect } from "react";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";

function GraciasPorSuCompra({ queryString, detallesCompra }) {

    const navigate = useNavigate();

    const params = new URLSearchParams(queryString);
    const paymentIntent = params.get("payment_intent") || "";
    const status = params.get("redirect_status");
    const isProcessing = status === "processing";

    // C3: limpiar localStorage al llegar a Gracias (compra completada).
    useEffect(() => {
        localStorage.removeItem("detallesCompra");
    }, []);

    const dateValue = Number(detallesCompra?.fechaObra)
    const date = dateValue ? new Date(dateValue).toLocaleDateString("es-ES", {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    }) : "";

    const cantidad = detallesCompra?.cantidad ?? 0;
    const titulo = detallesCompra?.titulo ?? "";

    if (isProcessing) {
        return (
            <>
                <h1>Estamos procesando tu pago</h1>
                <p>En cuanto el banco confirme la operación te enviaremos las entradas por email.</p>
                <p>{cantidad + " entrada(s) para " + titulo}</p>
                <p>{date}</p>
                <button type="button" onClick={(e) => { e.preventDefault(); navigate('/sala/programacion/') }}>Seguir navegando</button>
            </>
        );
    }

    return (
        <>
            <h1>Gracias por su compra</h1>
            <p>El siguiente QR corresponde a su entrada</p>
            <p>(También se lo hemos enviado a su email)</p>
            {paymentIntent
                ? <QRCode value={paymentIntent} />
                : <p style={{ color: "red" }}>No se pudo recuperar el código de tu entrada. Revisa tu email o contacta con la sala.</p>}
            <p>{cantidad + " entrada(s) para " + titulo}</p>
            <p>{date}</p>
            <p>Las entradas son sin numerar, se les asignará butaca a su llegado al teatro.</p>
            <p>Para personas con discapacidad, se aconseja ponerse en contacto con la sala en el 670 580 570 o info@lausina.es y se les reservarán butacas específicas.</p>
            <p>Gracias. </p>
            <button type="button" onClick={(e) => { e.preventDefault(); navigate('/sala/programacion/') }}>Seguir navegando</button>
        </>
    );
}

export default GraciasPorSuCompra;